export const setCookie = (name, value, expiredays, path = "/") => {
	let expData = new Date()
	expData.setDate(expData.getDate() + expiredays)
	document.cookie = `${name}=${escape(value)}; expires=${expData.toGMTString()}; path=${path}`
}
export const getCookie = (name) => {
	let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
	if (arr = document.cookie.match(reg)) return unescape(arr[2])
	else return null
}
export const delCookie = (name, domain, path = "/") => {
	let exp = new Date()
	exp.setTime(exp.getTime() - 1)
	let cval=getCookie(name)
	if(cval!=null&&!domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}`
	else if (cval!=null&&domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}; domain=${domain}`
}

export const getQueryParam = (paraName) => { // 获取指定的查询参数
    let queryStr = window.location.search.split('?')[1]
    if (!queryStr) return ''
    const paramArr = queryStr.split('&')
    for (let item of paramArr) {
        const itemStrArr = item.split('=')
        if (itemStrArr[0] == paraName) return itemStrArr[1]
    }
    return ''
}
export const spliceNum = (v,type)=>{
    console.log(v)
    let _v = v.split('.');
    let res;
    if(_v[1]==='00'){
        _v[0].length>4?res = 1:res = _v[0]
    } else if(v.lastIndexOf('.')===4){
        res = v.slice(0,4)
    }else if(v.length>5){
        res = v.slice(0,v.length-1)
    }else{
        res = v
    }
    return type ===0&&res!==1?res+'万':res+'亿'
};